import { apiCall } from './api';
import { EMAIL_TEMPLATES, EMAIL_TEMPLATE_DETAILS, EMAIL_TEMPLATE_STATUS, EMAIL_TEMPLATE_STATS } from '../config/api';

// Get all Email Templates
export const getEmailTemplates = async (params = {}) => {
  try {
    console.log('🚀 getEmailTemplates called with params:', params);
    console.log('🔗 Making API call to:', EMAIL_TEMPLATES);
    
    const response = await apiCall(EMAIL_TEMPLATES, {
      method: 'GET',
      params
    });
    
    console.log('📡 API Response from getEmailTemplates:', response);
    return response;
  } catch (error) {
    console.error('❌ Error in getEmailTemplates:', error);
    throw error;
  }
};

// Get Email Template by ID
export const getEmailTemplateById = async (templateId) => {
  try {
    const endpoint = EMAIL_TEMPLATE_DETAILS.replace('{id}', templateId);
    const response = await apiCall(endpoint, {
      method: 'GET'
    });
    return response;
  } catch (error) {
    console.error('Error fetching Email Template:', error);
    throw error;
  }
};

// Create new Email Template
export const createEmailTemplate = async (templateData) => {
  try {
    console.log('🚀 createEmailTemplate called with data:', templateData);
    console.log('🔗 Making API call to:', EMAIL_TEMPLATES);
    
    const response = await apiCall(EMAIL_TEMPLATES, {
      method: 'POST',
      data: templateData
    });
    
    console.log('📡 API Response from createEmailTemplate:', response);
    return response;
  } catch (error) {
    console.error('❌ Error creating Email Template:', error);
    throw error;
  }
};

// Update Email Template
export const updateEmailTemplate = async (templateId, templateData) => {
  try {
    const endpoint = EMAIL_TEMPLATE_DETAILS.replace('{id}', templateId);
    console.log('🚀 updateEmailTemplate called with ID:', templateId, 'and data:', templateData);
    console.log('🔗 Making API call to:', endpoint);
    
    const response = await apiCall(endpoint, {
      method: 'PUT',
      data: templateData
    });
    
    console.log('📡 API Response from updateEmailTemplate:', response);
    return response;
  } catch (error) {
    console.error('❌ Error updating Email Template:', error);
    throw error;
  }
};

// Delete Email Template
export const deleteEmailTemplate = async (templateId) => {
  try {
    const endpoint = EMAIL_TEMPLATE_DETAILS.replace('{id}', templateId);
    const response = await apiCall(endpoint, {
      method: 'DELETE'
    });
    return response;
  } catch (error) {
    console.error('Error deleting Email Template:', error);
    throw error;
  }
};

// Update Email Template status
export const updateEmailTemplateStatus = async (templateId, status) => {
  try {
    const endpoint = EMAIL_TEMPLATE_STATUS.replace('{id}', templateId);
    const response = await apiCall(endpoint, {
      method: 'PATCH',
      data: { status }
    });
    return response;
  } catch (error) {
    console.error('Error updating Email Template status:', error);
    throw error;
  }
};

// Get Email Template statistics
export const getEmailTemplateStats = async () => {
  try {
    const response = await apiCall(EMAIL_TEMPLATE_STATS, {
      method: 'GET'
    });
    return response;
  } catch (error) {
    console.error('Error fetching Email Template stats:', error);
    throw error;
  }
};

